export { default } from './SWSectionServicesBanner';
